// pages/mobile/FieldStaffApp.js
// Routes of the field staff mobile app, mounted at /m/* (FIELD_STAFF_HOME).
import React, { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { FIELD_STAFF_HOME } from '../../authentication/roles';
import DispatchPage from './DispatchPage';
import FieldStaffHome from './FieldStaffHome';
import InboxPage from './InboxPage';
import { watchPushSubscription } from './pushSubscription';
import RequestPage from './RequestPage';
import SetupPage from './SetupPage';
import WarningPage from './WarningPage';

const FieldStaffApp = () => {
  // Re-sends this phone's push subscription each time the app opens.
  useEffect(() => watchPushSubscription(), []);

  return (
  <Routes>
    <Route index element={<InboxPage />} />
    <Route path="setup" element={<SetupPage />} />
    <Route path="me" element={<FieldStaffHome />} />
    <Route path="dispatches/:id" element={<DispatchPage />} />
    <Route path="warnings/:id" element={<WarningPage />} />
    <Route path="requests/:id" element={<RequestPage />} />
    <Route path="*" element={<Navigate to={FIELD_STAFF_HOME} replace />} />
  </Routes>
  );
};

export default FieldStaffApp;
